import { buildModelManager } from "../builder.js";
const DefaultShopifyShopSelection = {
  __typename: true,
  id: true,
  state: true,
  activeCampaignCount: true,
  address1: true,
  address2: true,
  aiInsightsKillswitch: true,
  alerts: true,
  billingAddress: true,
  billingCycleAnchor: true,
  campaignLimit: true,
  cdnPathKey: true,
  city: true,
  confirmationUrl: true,
  cookieConsentLevel: true,
  countriesInShippingZones: true,
  country: true,
  countryCode: true,
  countryName: true,
  countyTaxes: true,
  createdAt: true,
  currency: true,
  currencyBackup: true,
  currencyFormats: true,
  currentPlan: true,
  customerAccounts: true,
  customerAccountsV2: true,
  customerEmail: true,
  description: true,
  disabledWebhooks: true,
  domain: true,
  eligibleForCardReaderGiveaway: true,
  eligibleForPayments: true,
  email: true,
  emailMarketingOptOut: true,
  emailMarketingOptOutAt: true,
  enabledPresentmentCurrencies: true,
  enabledPresentmentCurrenciesBackup: true,
  finances: true,
  firstCampaignCreatedAt: true,
  firstConversionAt: true,
  forceSsl: true,
  googleAppsDomain: true,
  googleAppsLoginEnabled: true,
  grantedScopes: true,
  hasDiscounts: true,
  hasGiftCards: true,
  hasStorefront: true,
  ianaTimezone: true,
  installedViaApiKey: true,
  lastBillingResetDate: true,
  lastEventAt: true,
  lastLifecycleEmailAt: true,
  lastSubscriptionCheck: true,
  latitude: true,
  longitude: true,
  marketingSmsContentEnabledAtCheckout: true,
  mauticContactId: true,
  moneyFormat: true,
  moneyInEmailsFormat: true,
  moneyWithCurrencyFormat: true,
  moneyWithCurrencyInEmailsFormat: true,
  monthlyAiCoPilotEditLimit: true,
  monthlyAiCoPilotEdits: true,
  monthlyAiOperationLimit: true,
  monthlyAiOperations: true,
  monthlyImpressionCount: true,
  monthlyImpressionLimit: true,
  monthlyVisitorCount: true,
  monthlyVisitorLimit: true,
  multiLocationEnabled: true,
  myshopifyDomain: true,
  name: true,
  nextBillingDate: true,
  onboardingStep: true,
  oneTimeChargeId: true,
  orderNumberFormatPrefix: true,
  orderNumberFormatSuffix: true,
  passwordEnabled: true,
  phone: true,
  planDisplayName: true,
  planHandle: true,
  planName: true,
  planPublicDisplayName: true,
  preLaunchEnabled: true,
  primaryLocale: true,
  province: true,
  provinceCode: true,
  recurringChargeId: true,
  registeredWebhooks: true,
  requiresExtraPaymentsAgreement: true,
  resourceLimits: true,
  reviewPromptLastAttemptAt: true,
  reviewPromptOutcome: true,
  reviewPromptShownCount: true,
  richTextEdiorUrl: true,
  setupCallBookedAt: true,
  setupCallPromptCyclePosition: true,
  setupCallPromptLastShownAt: true,
  setupCallPromptShownCount: true,
  setupRequired: true,
  shipsToCountries: true,
  shopAddress: true,
  shopOwner: true,
  shopSpecificRegistration: true,
  shopifyCreatedAt: true,
  shopifyUpdatedAt: true,
  smartTriggerKillswitch: true,
  smartTriggerWeights: true,
  source: true,
  subscriptionStatus: true,
  taxShipping: true,
  taxesIncluded: true,
  taxesOffset: true,
  themeEditorUrl: true,
  timezone: true,
  timezoneAbbreviation: true,
  timezoneOffsetMinutes: true,
  transactionalSmsDisabled: true,
  trialDays: true,
  trialStartedAt: true,
  unitSystem: true,
  updatedAt: true,
  url: true,
  usedTrialMinutes: true,
  weightUnit: true,
  weightUnitBackup: true,
  zipCode: true
};
const modelApiIdentifier = "shopifyShop";
const pluralModelApiIdentifier = "shopifyShops";
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyShopSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "cancelSubscriptionShopifyShop",
    operationReturnType: "CancelSubscriptionShopifyShop",
    functionName: "cancelSubscription",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      shopifyShop: { required: false, type: "CancelSubscriptionShopifyShopInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "bulkCancelSubscriptionShopifyShops",
    functionName: "bulkCancelSubscription",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "cancelSubscription",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCancelSubscriptionShopifyShopsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "changePlanShopifyShop",
    operationReturnType: "ChangePlanShopifyShop",
    functionName: "changePlan",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      shopifyShop: { required: false, type: "ChangePlanShopifyShopInput" },
      newPlanKey: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["newPlanKey"],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "bulkChangePlanShopifyShops",
    functionName: "bulkChangePlan",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "changePlan",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkChangePlanShopifyShopsInput!]" }
    },
    paramOnlyVariables: ["newPlanKey"],
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "checkReviewPromptEligibilityShopifyShop",
    operationReturnType: "CheckReviewPromptEligibilityShopifyShop",
    functionName: "checkReviewPromptEligibility",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: true,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "bulkCheckReviewPromptEligibilityShopifyShops",
    functionName: "bulkCheckReviewPromptEligibility",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "checkReviewPromptEligibility",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "checkSetupCallEligibilityShopifyShop",
    operationReturnType: "CheckSetupCallEligibilityShopifyShop",
    functionName: "checkSetupCallEligibility",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: true,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "bulkCheckSetupCallEligibilityShopifyShops",
    functionName: "bulkCheckSetupCallEligibility",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "checkSetupCallEligibility",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "checkSubscriptionStatusShopifyShop",
    operationReturnType: "CheckSubscriptionStatusShopifyShop",
    functionName: "checkSubscriptionStatus",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      shopifyShop: {
        required: false,
        type: "CheckSubscriptionStatusShopifyShopInput"
      }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "bulkCheckSubscriptionStatusShopifyShops",
    functionName: "bulkCheckSubscriptionStatus",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "checkSubscriptionStatus",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCheckSubscriptionStatusShopifyShopsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "recordReviewPromptOutcomeShopifyShop",
    operationReturnType: "RecordReviewPromptOutcomeShopifyShop",
    functionName: "recordReviewPromptOutcome",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      outcome: { required: false, type: "String" },
      success: { required: false, type: "Boolean" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["outcome", "success"],
    hasReturnType: true,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "bulkRecordReviewPromptOutcomeShopifyShops",
    functionName: "bulkRecordReviewPromptOutcome",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "recordReviewPromptOutcome",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkRecordReviewPromptOutcomeShopifyShopsInput!]"
      }
    },
    paramOnlyVariables: ["outcome", "success"],
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "recordSetupCallPromptOutcomeShopifyShop",
    operationReturnType: "RecordSetupCallPromptOutcomeShopifyShop",
    functionName: "recordSetupCallPromptOutcome",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      outcome: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["outcome"],
    hasReturnType: true,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "bulkRecordSetupCallPromptOutcomeShopifyShops",
    functionName: "bulkRecordSetupCallPromptOutcome",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "recordSetupCallPromptOutcome",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkRecordSetupCallPromptOutcomeShopifyShopsInput!]"
      }
    },
    paramOnlyVariables: ["outcome"],
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "subscribeShopifyShop",
    operationReturnType: "SubscribeShopifyShop",
    functionName: "subscribe",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      shopifyShop: { required: false, type: "SubscribeShopifyShopInput" },
      plan: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["plan"],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "action",
    operationName: "bulkSubscribeShopifyShops",
    functionName: "bulkSubscribe",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "subscribe",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkSubscribeShopifyShopsInput!]" }
    },
    paramOnlyVariables: ["plan"],
    defaultSelection: DefaultShopifyShopSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shopifyShopGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
operations.push(...[
  "update",
  "bulkUpdate",
  "install",
  "bulkInstall",
  "reinstall",
  "bulkReinstall",
  "uninstall",
  "bulkUninstall"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyShop does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyShopManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyShopSelection,
  operations
);
export {
  DefaultShopifyShopSelection,
  ShopifyShopManager
};
//# sourceMappingURL=ShopifyShop.js.map
